import Component from "@glimmer/component";
import { service } from "@ember/service";
import { action } from "@ember/object";
import { modifier } from "ember-modifier";
import { tracked } from "@glimmer/tracking";

export default class extends Component {
  @service session;
  @service modal;
  @service keyboard;

  get organization() {
    return this.args.organization;
  }

  get user() {
    return this.args.user;
  }

  get pendingInvitesCount() {
    return this.user?.invites?.length ?? 0;
  }

  @tracked shouldHaveBorder = false;

  @action
  signOut(status) {
    this.session.close.perform(status);
  }

  registerListeners = modifier(() => {
    this.keyboard.listenFor({ key: "?" }, () => this.modal.open("modals/hotkeys", {}));

    const handleScroll = () => (this.shouldHaveBorder = window.scrollY >= 80);

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      this.keyboard.stopListenFor({ key: "?" });
      window.removeEventListener("scroll", handleScroll);
    };
  });
}
